import { getApiUrl } from '../config/api';

export const getPublicAssetPath = (relativePath) => {
    const base = process.env.PUBLIC_URL || '';
    const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;
    const normalizedPath = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
    return `${normalizedBase}${normalizedPath}` || normalizedPath;
};

const isPdfBuffer = (buffer) => {
    const bytes = new Uint8Array(buffer);
    return bytes.length >= 4
        && bytes[0] === 0x25
        && bytes[1] === 0x50
        && bytes[2] === 0x44
        && bytes[3] === 0x46;
};

const validatePdfResponse = async (response, sourceLabel) => {
    if (!response.ok) {
        throw new Error(`${sourceLabel} 응답 오류 (${response.status})`);
    }

    const contentType = (response.headers.get('content-type') || '').toLowerCase();
    if (contentType.includes('xml') || contentType.includes('text/html')) {
        throw new Error(`${sourceLabel}에서 PDF가 아닌 응답을 받았습니다.`);
    }

    const buffer = await response.arrayBuffer();
    if (!isPdfBuffer(buffer)) {
        throw new Error(`${sourceLabel}의 파일이 유효한 PDF가 아닙니다.`);
    }

    return buffer;
};

export const fetchPdfTemplate = async (fileName) => {
    const staticPath = getPublicAssetPath(`/resources/${fileName}`);
    const sources = [
        { url: staticPath, label: '정적 파일' },
    ];

    const token = localStorage.getItem('token');
    if (token) {
        sources.push({
            url: `${getApiUrl()}/static-resources/pdf-templates/${encodeURIComponent(fileName)}`,
            label: 'API',
            auth: true,
        });
    }

    let lastError = null;

    for (const source of sources) {
        try {
            const headers = {};
            if (source.auth && token) {
                headers.Authorization = `Bearer ${token}`;
            }

            const response = await fetch(source.url, { headers });
            return await validatePdfResponse(response, source.label);
        } catch (error) {
            lastError = error;
            console.warn(`PDF 템플릿 로드 실패 (${source.label}):`, error.message);
        }
    }

    throw new Error(
        lastError?.message
        || 'PDF 템플릿을 불러올 수 없습니다. 페이지를 새로고침하거나 관리자에게 문의하세요.'
    );
};

export const fetchPublicAsset = async (relativePath, options = {}) => {
    const { optional = false } = options;
    const url = getPublicAssetPath(relativePath);

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`정적 파일 응답 오류 (${response.status})`);
        }
        return await response.arrayBuffer();
    } catch (error) {
        if (optional) {
            console.warn(`정적 파일 로드 실패 (${url}):`, error.message);
            return null;
        }
        throw error;
    }
};
